module.exports = __webpack_public_path__ + "img/13.b541ac26.jpg";